import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getOpenFlyouts (routing) {
  return ROUTING_STATE_SHAPE.getAt(routing, ['flyouts']);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getOpenFlyouts.js